// Lot Z (R-6, 13/09) — « une seule démarche ».
//
// Avant : le visiteur non connecté qui cliquait « Recevoir un devis » partait sur /register,
// puis devait REVENIR sur la commune, rouvrir la modale et recliquer. Deux démarches pour un
// seul geste d'achat.
//
// Après : l'intention de devis (le code INSEE de la commune) voyage avec le renvoi vers
// l'inscription, et le backend émet le devis au moment où il crée le compte.
//
// Pourquoi l'URL et pas un état de navigation : l'intention doit survivre au RECHARGEMENT de
// la page d'inscription — un mot de passe refusé, un retour arrière, un onglet rouvert. Un
// `location.state` se perd dès qu'on arrive par un lien collé ; une query string, jamais.
// Elle ne porte rien de sensible : un code commune et un nom de commune, tous deux publics.

export const INSEE_RE = /^[0-9][0-9AB][0-9]{3}$/

/** La réponse de POST /api/devis — et désormais aussi le champ `devis` de /api/auth/register. */
export interface DevisOk {
  reference: string
  montant_ht: number
  montant_ttc: number
  valide_jusqu_au: string
  email_envoye: boolean
  email: string
  pdf_url: string
}

export interface IntentionDevis {
  insee: string
  communeNom: string
}

/** Le lien « Créer mon compte » de la modale : il emporte l'intention. */
export function lienInscriptionDevis(insee: string, communeNom: string): string {
  const p = new URLSearchParams()
  p.set('devis', insee)
  if (communeNom) p.set('commune', communeNom)
  p.set('next', `/o/${insee}/synthese`)
  return `/register?${p.toString()}`
}

/** Relecture côté /register. Une intention illisible est ignorée (inscription normale) —
 *  jamais une erreur : on ne refuse pas un compte parce qu'une URL a été tronquée. */
export function lireIntentionDevis(search: string): IntentionDevis | null {
  const p = new URLSearchParams(search)
  const insee = (p.get('devis') || '').trim().toUpperCase()
  if (!INSEE_RE.test(insee)) return null
  return { insee, communeNom: (p.get('commune') || '').trim() }
}
